<template>
  <div>
    <div class="t_out_box">
      <div class="headerSearch">
        <el-form
          class="t_search_form"
          label-position="left"
          style="width: 90%; margin-left: auto; margin-right: auto"
          label-width="90px"
        >
          <el-form-item label="化学品：" label-width="100px">
            <el-input
              v-model="search.hxpmc"
              clearable
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="仓库名称：" label-width="85px">
            <el-select v-model="search.cfckbm" filterable placeholder="请选择">
              <el-option
                v-for="(item, index) in listckxx"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="入库日期:">
            <el-col :span="10">
              <el-date-picker
                v-model="search.beginTime"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
                :picker-options="startTime"
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="3">-</el-col>
            <el-col :span="10">
              <el-date-picker
                v-model="search.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择日期"
                clearable
                :picker-options="endTime"
              />
            </el-col>
          </el-form-item>

          <el-form-item label="状态：" label-width="60px">
            <el-select v-model="search.zt" clearable placeholder="请选择">
              <el-option
                v-for="item in ztkv"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-button
            v-preventReClick
            class="sousuoButton"
            icon="el-icon-search"
            round
            size="small"
            type="primary"
            @click="searchbtn"
          >搜索</el-button>
          <el-button
            v-preventReClick
            size="small"
            icon="el-icon-refresh-right"
            round
            @click="reset"
          >重置</el-button>
        </el-form>
      </div>
      <div class="t_con_w" style="padding-top: 40px; padding-bottom: 57px">
        <div style="width: 90%; margin-left: auto; margin-right: auto">
          <div
            style="
              background-color: #f4f4f4;
              padding: 12px 10px;
              border: 1px solid #f4f4f4;
            "
          >
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              type="primary"
              size="mini"
              style="background-color: #4170ff; border: none; color: white"
              @click="add(1)"
            >新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-plus"
              size="mini"
              style="margin-left: 10px; marign-right: 10px"
              @click="add(4)"
            >复制新增</el-button>
            <el-button
              v-preventReClick
              icon="el-icon-upload2"
              size="mini"
              @click="linkout"
            >导出</el-button>
          </div>
          <el-table
            ref="myTable"
            :data="tableData"
            :header-cell-style="{ background: '#f4f4f4', color: '#909399' }"
            border
            style="
              width: 100%;
              border-left: 1px solid #f4f4f4;
              border-right: 1px solid #f4f4f4;
            "
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column
              v-if="false"
              align="center"
              prop="id"
              :show-overflow-tooltip="true"
              label="id"
            />
            <el-table-column
              align="center"
              prop="rkbh"
              :show-overflow-tooltip="true"
              label="入库编号"
            />
            <el-table-column
              align="center"
              prop="hxpmc"
              :show-overflow-tooltip="true"
              label="化学品名称"
            />
            <!-- <el-table-column
              align="center"
              prop="rklxmc"
              :show-overflow-tooltip="true"
              label="入库类型"
            >
            </el-table-column> -->
            <el-table-column
              align="center"
              prop="cfckmc"
              :show-overflow-tooltip="true"
              label="仓库名称"
            />
            <el-table-column
              align="center"
              prop="rksl"
              :show-overflow-tooltip="true"
              label="入库数量"
            >
              <template slot-scope="scope">
                {{ scope.row.rksl }}{{ scope.row.rksldwmc }}
              </template>
            </el-table-column>

            <el-table-column
              v-if="false"
              align="center"
              prop="rksldwmc"
              :show-overflow-tooltip="true"
              label="入库数量单位名称"
            />
            <el-table-column
              align="center"
              prop="bgyxm"
              :show-overflow-tooltip="true"
              label="保管员"
            />
            <el-table-column
              align="center"
              prop="rkrq"
              :show-overflow-tooltip="true"
              label="入库日期"
            />
            <el-table-column
              align="center"
              prop="bgcs"
              :show-overflow-tooltip="true"
              label="变更次数"
            >
              <template slot-scope="scope">
                <span
                  v-preventReClick
                  style="cursor: pointer"
                  @click="bgcsClick(scope.row)"
                >{{ scope.row.bgcs }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="zt"
              label="状态"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.zt == '01'" style="color: #6fc89a">{{
                  scope.row.ztMc
                }}</span>
                <span v-if="scope.row.zt == '11'" style="color: #43a5e2">{{
                  scope.row.ztMc
                }}</span>
                <span v-if="scope.row.zt == '00'" style="color: #333333">{{
                  scope.row.ztMc
                }}</span>
                <span v-if="scope.row.zt == '21'" style="color: #413bf4">{{
                  scope.row.ztMc
                }}</span>
                <span v-if="scope.row.zt == '23'" style="color: red">{{
                  scope.row.ztMc
                }}</span>
                <span v-if="scope.row.zt == '13'" style="color: #f8140d">{{
                  scope.row.ztMc
                }}</span>
                <span v-if="scope.row.zt == '24'" style="color: #6fc89a">{{
                  scope.row.ztMc
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="cz"
              width="200px"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="
                    scope.row.zt == '01' ||
                      scope.row.zt == '11' ||
                      scope.row.zt == '21' ||
                      scope.row.zt == '23' ||
                      scope.row.zt == '24' ||
                      scope.row.zt == '13'
                  "
                  v-preventReClick
                  size="mini"
                  icon="el-icon-document"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(3, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.zt == '01'||
                    scope.row.zt == '13'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #feb800; border: none; color: white"
                  @click="add(5, scope.row)"
                >变更</el-button>
                <el-button
                  v-if="scope.row.zt == '11'"
                  v-preventReClick
                  disabled
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #c8c9cc; border: none; color: white"
                  @click="add(5, scope.row)"
                >变更</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-edit"
                  style="background-color: #4170ff; border: none; color: white"
                  @click="add(2, scope.row)"
                >编辑</el-button>
                <el-button
                  v-if="scope.row.zt == '00'"
                  v-preventReClick
                  size="mini"
                  icon="el-icon-delete"
                  style="background-color: #ff5721; border: none; color: white"
                  @click="delitem(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :page-size="1"
            class="el-page"
            @current-change="currentChange"
            @size-change="sizeChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <el-dialog
      v-if="digshow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="digshow"
      width="1200px"
      @close="dialogClose"
    >
      <div class="t_dig" v-loading = "loading">
        <div style="font-weight: bold; font-size: 20px; text-align: center">
          {{ tetle }}
        </div>
        <div style="background-color: white">
          <div class="t_rk">
            <el-form
              ref="ruleForm"
              label-position="right"
              :rules="rules"
              :model="additem"
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
              "
              label-width="130px"
            >
              <!-- <el-form-item
                label="入库类型："

                prop="rklxmc"
                style="margin-right: 0; width: 45%"
              >
                <el-select placeholder="请选择" v-model="additem.rklxmc"
                @change='rkchange'
                :disabled='btntype==3' style="width: 100%">
                  <el-option v-for="(item,index) in rklxkv" :key="index" :label="item.label" :value="`${item.label}|${item.value}`"></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item
                v-if="syckbmshow"
                label="使用出库编码："
                prop="syckbm"
                style="margin-right: 0; width: 45%"
              >
                <el-select placeholder="请选择" v-model="additem.syckbm" :disabled='btntype==3' style="width: 100%">
                  <el-option v-for="(item,index) in syckbmkv" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item
                label="可回库存量："
                prop="khksl"
                style="margin-right: 0; width: 45%"

              >
                <el-input v-model="additem.khksl" type="number" :disabled='btntype==3' style="width: 60%"></el-input>
                <el-select
                  v-model="additem.khlsldwmc"
                  :disabled='btntype==3'
                  placeholder="单位"
                  style="width: 35%; margin-left: 5%"
                >
                  <el-option v-for="(item,index) in dwkv" :key="index" :label="item.label" :value="`${item.label}|${item.value}`"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item
                label="化学品："
                prop="hxpmc"
                style="margin-right: 0; width: 45%"
              >
                <el-cascader
                  style="width: 100%"
                  v-model="additem.hxpbm"
                  v-if="!(btntype == 3 || bgdisable)"
                  placeholder="请选择化学品"
                  :options="options"
                  check-strictly
                  :props="{ expandTrigger: 'hover' }"
                  @change="handleChange"
                />
                <el-input
                  v-else
                  disabled
                  v-model="additem.hxpmc"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="存放仓库："
                prop="cfckmc"
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-if="btntype == 3"
                  v-model="additem.cfckmc"
                  disabled
                  style="width: 100%"
                />
                <el-select
                  v-else
                  v-model="additem.cfckbm"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="ckChange"
                >
                  <!-- :value="`${item.label}|${item.value}`" -->
                  <el-option
                    v-for="(item, index) in cfckkv"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="入库数量："
                prop="rksl"
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="additem.rksl"
                  :disabled="btntype == 3"
                  style="width: 60%"
                />
                <el-select
                  v-model="additem.rksldw"
                  :disabled="btntype == 3"
                  placeholder="单位"
                  style="width: 35%; margin-left: 5%"
                >
                  <el-option
                    v-for="(item, index) in dwkv"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                label="入库日期："
                prop="rkrq"
                style="margin-right: 0; width: 45%"
              >
                <el-date-picker
                  v-model="additem.rkrq"
                  :picker-options="pickerBeginDateBefore"
                  style="width: 100%"
                  :disabled="btntype == 3"
                  type="date"
                  placeholder="选择日期"
                />
              </el-form-item>
              <el-form-item
                label="保管员姓名："
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="additem.bgyxm"
                  disabled
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="保管员电话："
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="additem.bgydh"
                  disabled
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="经办人："
                prop="jbr"
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-if="btntype == 3 || bgdisable"
                  v-model="additem.jbrxm"
                  disabled
                  style="width: 100%"
                />
                <el-select
                  v-else
                  v-model="additem.jbr"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                  @change="jbrChange"
                >
                  <el-option
                    v-for="(item, index) in jbrList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="djsjdisable"
                label="登记时间："
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="additem.djsj"
                  disabled
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item v-else label="登记时间:" style="margin-right: 0; width: 45%">
                <el-date-picker
                  :value="new Date()"
                  type="date"
                  style="width: 100%;"
                  placeholder="选择日期"
                  disabled
                  format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
              <el-form-item
                label="登记人："
                style="margin-right: 0; width: 45%"
              >
                <el-input
                  v-model="curDjr"
                  disabled
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                label="备注："
                style="margin-right: 0; width: 100%"
                prop="bz"
              >
                <el-input
                  v-model="additem.bz"
                  :disabled="btntype == 3 || bgdisable"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                v-if="type == 5"
                label="变更理由"
                style="margin-right: 0; width: 100%"
                prop="bgly"
              >
                <el-input v-model="additem.bgly" style="width: 100%" />
              </el-form-item>
            </el-form>
            <splcCom
              v-if="tetle == '查看其他入库' || tetle == '变更其他入库'"
              ref="splcRef"
            />
            <div
              v-if="
                (tetle == '查看其他入库' || tetle == '变更其他入库') &&
                  curRowObj.bgcs > 0
              "
            >
              <div class="title" style="margin: 40px 0 50px 0">
                <img src="../assets/img/bgsp/rkbg.png" alt="" srcset="">
              </div>
              <bgcsOfDetail
                :cur-row-obj="curRowObj"
                :cur-type="'2'"
                :bgcs-t-k-name="'disShow'"
                @bacsCkXqShow="bacsCkXqShow"
              />
            </div>
            <!-- 新增 -->
            <div
              v-if="type == 1 || type == 4"
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                display: flex;
                justify-content: space-around;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  background-color: #ebebeb;
                  width: 148px;
                  height: 60px;
                  color: #333333;
                  border: none;
                "
                @click="saveAddItemTemp('ruleForm')"
              >暂时保存</el-button>
              <el-button
                v-preventReClick
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                type="primary"
                @click="saveAddItem('ruleForm', '入库')"
              >入库</el-button>
            </div>
            <!-- 查看 -->
            <div
              v-if="type == 3"
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                display: flex;
                justify-content: center;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                @click="digshow = false"
              >确定</el-button>
            </div>
            <!-- 变更 -->
            <div
              v-if="type == 5"
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                display: flex;
                justify-content: center;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                @click="submitBG('ruleForm')"
              >提交变更</el-button>
            </div>
            <!-- 编辑 -->
            <div
              v-if="type == 2"
              style="
                width: 498px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 40px;
                margin-bottom: 45px;
                display: flex;
                justify-content: center;
              "
            >
              <el-button
                v-preventReClick
                type="primary"
                style="
                  margin-right: 190px;
                  background-color: #ebebeb;
                  width: 148px;
                  height: 60px;
                  color: #333333;
                  border: none;
                "
                @click="saveAddItemTemp"
              >暂时保存</el-button>
              <el-button
                v-preventReClick
                style="
                  background-color: #4170ff;
                  color: white;
                  width: 148px;
                  height: 60px;
                  border: none;
                "
                type="primary"
                @click="saveAddItem('ruleForm', '入库')"
              >入库</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="produce_pup">
      <!-- 详情弹框 -->
      <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
        <bgxqCom
          v-if="dialogFormVisible"
          :bgcs-t-k-name="bgcsTKName"
          :dgcs-xq-id="dgcsXqId"
        />
        <div slot="footer" class="dialog-footer">
          <el-button
            v-preventReClick
            type="primary"
            style="background-color: #4170ff; border: none"
            @click="dialogFormVisible = false"
          >确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import splcCom from '../components/bgxq/splccom.vue'
import bgxqCom from '../components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '../components/bgxq/bgInDetail.vue'
// 获取接口地址
import {
  gethxpJl,
  getListCkcx,
  userInfofLogin, getkv
} from '@/assets/js/common.js'
import bgcs from '@/components/bgcs'
import { lengthValidate } from '@/assets/js/validate.js'
import { getJbrListToKc, getdwselectionByhxp } from '@/assets/js/xsck.js' // 经办人
import {
  addrk,
  editById,
  bgBefore,
  bgFinall,
  getQtrkList,
  crkspEnum,
  getckMcOptions,
  detail,
  excelwriter, deleteById, addrkTemp, editByIdTemp
} from '@/assets/js/qtrk.js' // 仓库
export default {
  name: 'Qtrk',
  components: { bgcs, splcCom, bgcsOfDetail, bgxqCom },
  data() {
    // 入库数量rcsljiaoyan
    const rcsljiaoyan = (rule, value, callback) => {
      if (!this.additem.rksl) {
        callback(new Error('请填写入库数量!'))
      }
      // else if (this.additem.rksl < 0) {
      //   callback(new Error("请填写不小于0的入库数量值"));
      // }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/;
      if (!this.bgdisable && !reg.test(this.additem.rksl)) {
        callback(new Error("请输入大于或等于0的数量值"));
      }
      if (/^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false) {
        callback(new Error('整数位最大长度9位,保留3位小数'))
      } else if (!this.additem.rksldw) {
        callback(new Error('请选择入库数量单位!'))
      } else {
        callback()
      }
    }
    // 经办人
    const jbrjiaoyan = (rule, value, callback) => {
      if (!this.additem.jbr) {
        callback(new Error('请选择经办人!'))
      } else {
        callback()
      }
    }
    // 存放仓库
    const cfckjiaoyan = (rule, value, callback) => {
      if (!this.additem.cfckbm) {
        callback(new Error('请选择存放仓库!'))
      } else {
        callback()
      }
    }
    // 化学品
    const hxpjiaoyan = (rule, value, callback) => {
      if (!this.additem.hxpbm) {
        callback(new Error('请选择化学品!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      dgcsXqId: null,
      dialogFormVisible: false,
      curType: '',
      curRowObj: {}, // 当前行的对象
      bgcsTKName: '其他入库',
      spyjObj: [],
      startTime: {
        disabledDate: (time) => {
          if (this.search.endTime) {
            return time.getTime() > new Date(this.search.endTime).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.search.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.search.beginTime).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      bgwindow: false,

      curstatus: '',
      curDjr: '', // 当前登记人
      jbrList: [], // 获取经办人list
      options: [], // 化学品级联
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tetle: '新增其他入库',
      // 登记时间展示
      djsjdisable: false,
      digshow: false,
      // 变更不展示
      bgdisable: false,
      // 总条数
      total: null,
      // 每页条数
      pageSizes: 10,
      // 当前页
      nowpage: 1,
      // 状态kv
      ztkv: [],
      tableData: [],
      // 搜索
      search: {
        cfckbm: '',
        hxpmc: '',
        beginTime: '',
        endTime: '',
        zt: ''
      },
      // 当前选择
      nowitem: [],
      // 新增
      additem: {
        id: '',
        hxpbm: '', // 化学品编码
        cfckbm: '', // 存放仓库编码
        rksl: null, // 入库数量
        rksldw: '', // 入库数量单位
        rkrq: '', // 入库日期
        jbr: '', // 经办人
        jbrxm: '', // 经办人姓名
        bz: '', // 备注
        bgyId: '', // 保管员信息从仓库接口里获取
        bgyxm: '', // 保管员姓名
        bgydh: '', //  保管员电话
        zt: '', // 00 草稿 01保存
        bgly: ''
      },
      bg_before_save: {
        id: '',
        hxpbm: '',
        cfckbm: '',
        rksl: null,
        rksldw: '', // value值
        rkrq: '', // 日期
        bgly: '' // 变更理由
      },
      /*
              // id: "", //入库编码
        // rkbh: "", //入库编码
        // zt: "", //状态

        // khlsldwmc: "", //可回库数量单位名称
        // rksl: null, //入库数量
        // rksldw: "", //入库数量单位
        // rksldwmc: "", //入库数量单位名称
        // bgyxm: "", //保管员姓名
        // bgydh: "", //保管员电话
        // bz: "", //备注
        // hxpbm: "", //化学品编码
        // hxpmc: "", //化学品
        // cfckbm: "", //存仓仓库编码
        // cfckmc: "" //存仓仓库名称 */
      // form中转
      formzz: {},
      // 按钮中转
      btntype: null,
      // 入库类型
      rklxkv: [],
      // 使用出库编码
      // syckbmkv:[
      //   {
      //     "value": "00",
      //     "label": "0000000"
      //   },
      //   {
      //     "value": "11",
      //     "label": "1111"
      //   },
      // ],
      // 单位
      dwkv: [],
      // 存放仓库
      cfckkv: [],
      listckxx: [],
      // 使用出库编码是否展示
      // syckbmshow:true,
      // 校验规则
      rules: {
        hxpmc: [{ required: true, validator: hxpjiaoyan, trigger: 'change' }],
        cfckmc: [{ required: true, validator: cfckjiaoyan, trigger: 'change' }],
        jbr: [{ required: true, validator: jbrjiaoyan, trigger: 'change' }],
        rksl: [
          {
            required: true,
            validator: rcsljiaoyan,
            trigger: ['blur', 'change']
          }
        ],
        bgly: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        rkrq: [{ required: true, message: '请选择', trigger: 'blur' }],
        bz: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 500)
            },
            trigger: ['blur', 'change']
          }
        ]

        // jbr: [{ required: true, message: "请选择经办人：", trigger: "blur" }],
        // cfckmc: [
        //   { required: true, message: "请选择存放仓库：", trigger: "blur" }
        // ],
      },
      type: 0
    }
  },
  created: function() {
    // 获取列表
    this.getlist()
    // 状态kv
    this.ztkvfunc()
    // 列表查询仓库listckxx
    this.getListCkcxfunc()
    // 单位
    // this.dwfunc();@y
    // 入库类型
    this.rklxfunc()
    // 化学品级联
    this.getHXP()
    // 当前登录人
    this.getLoginInfo()
    /*
    1.编辑和保存的字段不同
    2.入库日期
    3.经办人
    */
  },
  methods: {
    lengthValidate,
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    // 点击变更次数
    bgcsClick(curRow) {
      // this.curRowObj = curRow;
      this.$bus.emit('bgcsOpen', curRow, '2')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 根据化学品编码查询单位下拉
    getDwSelectByhxpbm(hxpbm) {
      getdwselectionByhxp(hxpbm).then((res) => {
        if (res.status == 200) {
          this.dwkv = res.data.data
        }
      })
    },
    dialogClose() {
      this.$refs.ruleForm.resetFields()
    },
    // 确认变更
    confirmBG() {
      this.loading = true
      bgFinall(this.additem).then((res) => {
        this.loading = false
        this.getlist()
        this.digshow = false
        this.$refs['ruleForm'].clearValidate()
        this.$message.success('提交变更成功!')
      }).catch((error) => {
        this.loading = false
      })
    },
    // 提交变更
    submitBG(formValidate) {
      let qt_bg_validate = false
      this.$refs[formValidate].validate((valid) => {
        qt_bg_validate = valid
      })
      if (qt_bg_validate) {
        // 1.变更前校验2.变更成功接口3.确认变更
        bgBefore(this.additem).then((res) => {
          if (res.data.data.type == 'success') {
            this.$confirm('确定提交吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then((res) => {
              this.confirmBG()
            })
          } else {
            this.$confirm(
              "<span style='color:red'>" +
                res.data.data.msg +
                '</span>,是否确认提交变更?',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }
            ).then((res) => {
              this.confirmBG()
            })
          }
        })
      }
    },
    // 新增/编辑(暂时保存)
    saveAddItemTemp() {
      // 1.校验2.确认信息3.调接口保存
      this.additem.zt = '00'
      this.$confirm('确认暂时保存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
          .then((res) => {
            if (this.tetle == '新增其他入库' || this.type == 4) {
              this.loading = true
              addrkTemp(this.additem).then((res) => {
                this.loading = false
                this.getlist()
                this.digshow = false
                this.$refs['ruleForm'].clearValidate()
                this.$message.success('暂时保存成功!')
              }).catch((error) => {
                this.loading = false
              })
            } else if (this.tetle == '编辑其他入库') {
              this.loading = true
              editByIdTemp(this.additem).then((res) => {
                this.loading = false
                this.getlist()
                this.digshow = false
                this.$message.success('暂时保存成功!')
              }).catch((error) => {
                this.loading = false
              })
            }
          })
          .catch((err) => {
            return
          })
    },
    // 新增/编辑(入库)
    saveAddItem(formValidate, confirmTip) {
      // 1.校验2.确认信息3.调接口保存
      let qt_rk_validate = false
      this.$refs[formValidate].validate((valid) => {
        qt_rk_validate = valid
      })
      this.additem.zt = confirmTip == '入库' ? '01' : '00'
      if (qt_rk_validate) {
        this.$confirm('确认' + confirmTip + '吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then((res) => {
            if (this.tetle == '新增其他入库' || this.type == 4) {
              this.loading = true
              addrk(this.additem).then((res) => {
                this.loading = false
                this.getlist()
                this.digshow = false
                this.$refs['ruleForm'].clearValidate()
                this.$message.success(confirmTip + '成功!')
              }).catch((error) => {
                this.loading = false
              })
            } else if (this.tetle == '编辑其他入库') {
              this.loading = true
              editById(this.additem).then((res) => {
                this.loading = false
                this.getlist()
                this.digshow = false
                this.$message.success(confirmTip + '成功!')
              }).catch((error) => {
                this.loading = false
              })
            }
          })
          .catch((err) => {
            return
          })
      }
    },
    // 获取登录人信息
    getLoginInfo() {
      userInfofLogin().then((res) => {
        this.curDjr = res.data.data.name
      })
    },
    jbrChange(val) {
      this.jbrList.forEach((item) => {
        if (val == item.value) {
          this.additem.jbr = item.value
          this.additem.jbrxm = item.label
        }
      })
    },
    // change仓库
    ckChange(val) {
      this.cfckkv.forEach((item) => {
        if (item.value == val) {
          this.additem.bgyId = item.ckbgyId
          this.additem.bgyxm = item.ckbgy
          this.additem.bgydh = item.ckbgyDh
        }
      })
    },
    rk() {},
    zc() {},
    getHXP() {
      // 获取化学品级联数据
      gethxpJl().then((e) => {
        this.options = e.data.data
      })
    },
    // 化学品级联
    handleChange(value) {
      if (value == undefined) return
      this.additem.hxpbm = value[value.length - 1]
      this.getDwSelectByhxpbm(this.additem.hxpbm)
      this.additem.rksl = null
      this.additem.rksldw = ''
    },
    // 列表
    getlist() {
      getQtrkList({
        page: this.nowpage,
        size: this.pageSizes,
        param: this.search
      }).then((e)=> {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 每页条数变换
    sizeChange(val) {
      this.pageSizes = val
      // 重新获取列表
      this.getlist()
    },
    // 翻页
    currentChange(val) {
      this.nowpage = val
      // 重新获取列表
      this.getlist()
    },
    // 单选
    handleSelectionChange(val) {
      // 若存在一条数据 再次点击 该函数会执行三次 若没有数据选中，执行一次
      // 第一次 选中状态 val中有两条数据 => 走if
      // 第二次 清空数据 val为空  => 不走if
      // 第三次 将最后一条数据设置为选中状态 val有一条数据 =>不走if
      this.selectedRows = val

      if (val.length > 1) {
        this.$refs.myTable.clearSelection()
        this.$refs.myTable.toggleRowSelection(val.pop())
      }
      if (val.length != 0) {
        this.selectProtocolId = val[val.length - 1].id
      }

      this.nowitem = this.selectedRows
    },
    // 入库类型修改
    // rkchange(val){
    //   if(val.split('|')[0]=='使用回库'){
    //     this.syckbmshow=true
    //   }else{
    //     this.syckbmshow=false
    //   }
    // },
    // 状态kv
    ztkvfunc() {
      crkspEnum().then((e) => {
        this.ztkv = e.data.data
      })
    },
    // 重置
    reset() {
      this.search.cfckbm = ''
      this.search.hxpmc = ''
      this.search.beginTime = ''
      this.search.endTime = ''
      this.search.zt = ''
      // 重新获取列表
      this.getlist()
    },
    // 搜索
    searchbtn() {
      // 重新获取列表
      this.getlist()
    },
    // 仓库名称
    ckmckvfunc(dataMes) {
      if(this.type == '5'){ //变更
        getckMcOptions(dataMes.cfckbm).then((e) => {
            this.cfckkv = e.data.data
            this.additem.cfckbm = dataMes.cfckbm
            this.additem.cfckmc = dataMes.cfckmc
          })
      }else{
        getckMcOptions().then((e) => {
            this.cfckkv = e.data.data
            if(dataMes && dataMes.cfckbm){
              this.cfckkv.findIndex((item) => {
                if(item.value == dataMes.cfckbm){
                  this.additem.cfckbm = dataMes.cfckbm
                  this.additem.cfckmc = dataMes.cfckmc
                  this.additem.bgyId = dataMes.bgyId
                  this.additem.bgydh = dataMes.bgydh
                  this.additem.bgyxm = dataMes.bgyxm
                  return
                }
              })
            }
          })
        getJbrListToKc().then((res) => {
          this.jbrList = res.data.data
          if(dataMes && dataMes.jbr){
            this.jbrList.findIndex((item) => {
              if(item.value == dataMes.jbr){
                this.additem.jbr = dataMes.jbr
                this.additem.jbrxm = dataMes.jbrxm
                return
              }
            })
          }
        })

      }

    },
    // 列表查询仓库名称
    getListCkcxfunc() {
      getListCkcx()
        .then((e) => {
          this.listckxx = e.data.data
        })
    },

    // 入库类型
    rklxfunc() {
      getkv('yzd_qtrk_lx')
        .then((e) => {
          this.rklxkv = e.data.data
        })
    },
    // 新增-编辑-查看
    add(type, row) {
      // 清空校验结果
      // this.$refs["ruleForm"] ? this.$refs["ruleForm"].clearValidate() : null;
      this.type = type
      if (type == 1) {
        this.ckmckvfunc()
        // 新增
        this.digshow = !this.digshow
        this.btntype = type
        this.djsjdisable = false
        this.bgdisable = false
        this.tetle = '新增其他入库'
        this.additem = {
          hxpbm: '', // 化学品编码
          cfckbm: '', // 存放仓库编码
          rksl: null, // 入库数量
          rksldw: '', // 入库数量单位
          rkrq: '', // 入库日期
          jbr: '', // 经办人
          jbrxm: '', // 经办人姓名
          bz: '', // 备注
          bgyId: '', // 保管员信息从仓库接口里获取
          bgyxm: '', // 保管员姓名
          bgydh: '', //  保管员电话
          zt: '' // 00 草稿 01保存
        }
      } else if (type == 2) {
        // 编辑
        this.digshow = !this.digshow
        // 查看接口
        this.ckapi(row.id)
        this.btntype = type
        this.djsjdisable = true
        this.bgdisable = false
        this.tetle = '编辑其他入库'
      } else if (type == 3) {
        // 查看
        this.digshow = !this.digshow
        // 查看接口
        this.ckapi(row.id)
        this.btntype = type
        this.djsjdisable = true
        this.bgdisable = false
        this.tetle = '查看其他入库'
        this.curRowObj = row
      } else if (type == 4) {
        this.djsjdisable = true
        this.bgdisable = false
        // 复制新增
        if (this.nowitem.length == 0) {
          this.$message.error('您没有选择复制项！')
        } else {
          this.btntype = type
          this.digshow = !this.digshow
          this.ckapi(this.nowitem[0].id)
        }
        this.tetle = '新增其他入库'
      } else if (type == 5) {
        // 变更
        this.digshow = !this.digshow
        // 查看接口
        this.ckapi(row.id)
        this.btntype = type
        this.djsjdisable = true
        this.bgdisable = true
        this.tetle = '变更其他入库'
        this.curRowObj = row
      }
      setTimeout(() => {
        this.$refs.ruleForm.resetFields()
      }, 30)
    },
    // 暂存
    tj(type) {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.formzz = JSON.parse(JSON.stringify(this.additem))

          this.formzz.zt = type

          var kv1 = this.formzz.cfckmc.split('|')
          this.formzz.cfckbm = kv1[1]
          this.formzz.cfckmc = kv1[0]

          // var kv2=this.formzz.khlsldwmc.split('|')
          // this.formzz.khksldw=kv2[1]
          // this.formzz.khlsldwmc=kv2[0]

          // var kv3=this.formzz.rklxmc.split('|')
          // this.formzz.rklxbm=kv3[1]
          // this.formzz.rklxmc=kv3[0]

          var kv4 = this.formzz.rksldwmc.split('|')
          this.formzz.rksldw = kv4[1]
          this.formzz.rksldwmc = kv4[0]

          if (type == '00') {
            // 暂存
            var tips = '是否确定执行该操作?'
          } else if (type == '01') {
            // 提交
            var tips = '提交后不可撤回，确定入库并提交公安审批?'
          }

          this.$confirm(tips, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              // 判断接口
              if (this.btntype == 1 || this.btntype == 4) {
                if (this.btntype == 4) {
                  this.formzz.id = ''
                }
                addrk(this.formzz)
                  .then((e) => {
                    // 重新获取列表
                    this.getlist()
                    this.digshow = !this.digshow
                    if (type == '00') {
                      this.$message({
                        message: '暂存成功！',
                        type: 'success'
                      })
                    } else if (type == '01') {
                      this.$message({
                        message: '入库成功！',
                        type: 'success'
                      })
                    }
                  })
              } else if (this.btntype == 2) {
                // 编辑
                editById(this.formzz)
                  .then((e) => {
                    // 重新获取列表
                    this.getlist()
                    this.digshow = !this.digshow
                    if (type == '00') {
                      this.$message({
                        message: '暂存成功！',
                        type: 'success'
                      })
                    } else if (type == '01') {
                      this.$message({
                        message: '入库成功！',
                        type: 'success'
                      })
                    }
                  })
              }
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        } else {
          return false
        }
      })
    },
    // 查看接口
    ckapi(id) {
      detail(id).then((e) => {
        let mesxx = {...e.data.data}
        // 查看和变更
        if (this.type == '3' || this.type == '5') {
          this.$refs.splcRef.dataobj = e.data.data.sphjDtoList
        }
        if(this.type != '3'){
          mesxx.cfckbm = ''
          mesxx.cfckmc = ''
          if(this.type != '5'){
            mesxx.bgyId = ''
            mesxx.bgydh = ''
            mesxx.bgyxm = ''
            mesxx.jbr = ''
            mesxx.jbrxm = ''
          }
        }
        this.additem = mesxx
        if(this.type!='3'){
          this.ckmckvfunc(e.data.data)
        }
        if (this.type == 2 && this.additem.hxpbm) {
          this.getDwSelectByhxpbm(this.additem.hxpbm)
        }
        if (this.type == 3 && this.additem.hxpbm) {
          this.getDwSelectByhxpbm(this.additem.hxpbm)
        }
        if (this.type == 4 && this.additem.hxpbm) {
          this.getDwSelectByhxpbm(this.additem.hxpbm)
          this.additem.id = ''
        }
        if (this.type == 5 && this.additem.hxpbm) {
          // 根据化学品编码获取单位下拉
          this.getDwSelectByhxpbm(this.additem.hxpbm)
        }
        this.$nextTick(() => {
          this.$refs["ruleForm"] ? this.$refs["ruleForm"].clearValidate() : null; //清楚页面所有校验结果
        })
      })
    },
    // 导出
    linkout() {
      excelwriter(this.search).then((res) => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = '其他入库' + '.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
      })
    },
    // 删除按钮
    delitem(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteById(row.id)
            .then((e) => {
              // 重新获取列表
              this.getlist()
              this.$message({
                message: '删除成功！',
                type: 'success'
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style scoped lang="less">
.t_out_box {
  width: 95%;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1518px;
  .headerSearch {
    max-width: 1518px;

    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    margin-left: auto;
    margin-right: auto;

    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.t_con_w {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}
.t_search_form {
  display: flex;
  margin-bottom: 10px;
}
.t_search_form .el-form-item {
  margin-right: 30px;
  margin-bottom: 0;
}
.t_search_btn {
  width: 90px;
  height: 39px;
  background-color: #4170ff;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/* ------- */
.t_dig {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1200px;
  padding-top: 10px;
}
.t_xkz,
.t_rk {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
  padding-bottom: 20px;
}
.sousuoButton {
  margin-left: 20px;
  color: #fff;
  background: #4170ff;
  border-color: #4170ff;
}
.el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;

  border: 1px solid #ebeef5;
  border-top: 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/ .el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}
</style>
